///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/store/handling"/>

import * as asyncStore from "Core/Medius.Core.Web/Scripts/Medius/lib/store/async";
import * as memoryStore from "Core/Medius.Core.Web/Scripts/Medius/lib/store/memory";

const prefix = "task-handling",
    backend = memoryStore.create(),
    store = asyncStore.create(backend, prefix);

export = store;